import { Box, FormControl, Grid, InputLabel, Select, MenuItem, makeStyles, Typography, IconButton, Button, Popover, Chip } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import update from 'immutability-helper';

const useStyles = makeStyles((theme)=> ({
    container: {
        display: 'flex', 
        flexDirection: 'row', 
        margin: theme.spacing(1)
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 250
    },
    chips: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        '& > *': {
        margin: theme.spacing(0.5),
        }
    },
    addFilterButton: {
        marginLeft: theme.spacing(1)
    }
}))

function ResendOrderFilter(props){
    const {filterModel, onFilterChange} = props;
    const classes = useStyles();
    const {t} = useTranslation('resendOrders');

    const [filter, setFilter] = useState([]);
    const [openFilters, setOpenFilters] = useState(false);

    const [filterFieldName, setFilterFieldName] = useState('');
    const [filterFieldValue, setFilterFieldValue] = useState('');

    useEffect(() => {
        onFilterChange(filter)
    }, [filter])

    const _handleToggleFilterPopover = () => {
        setOpenFilters(!openFilters)
        setFilterFieldName('')
        setFilterFieldValue('')
    }

    const getFilterValues = (items, filter) => {
        let result = _.find(items, {columnField: filter})
        if(result === undefined){
            return {}
        } else {
            return result
        }
    }

    const _handleFilterComplete = (value) => {
        setFilterFieldValue(value)
        let newFilter = update(filter, {$push: [{field: filterFieldName, value}]})
        setFilter(_.uniqBy(newFilter.reverse(), 'field'))
        _handleToggleFilterPopover()
    }

    const _removeFilter = (id) => {
        let filtered = _.filter(filter, (item)=>{
            return item.field !== id
        })
        setFilter(filtered)
    }

    const getFilterDisplayName = (value) => {
        let foundFilter = _.find(filterModel.items, {'columnField': value})
        if(foundFilter === undefined){
            return value
        }
        if(_.has(foundFilter, 'displayName')){
            return foundFilter.displayName
        } else {
            return foundFilter.columnField
        }
    }

    return (
        <Box>
            <div className={classes.container}>
                <Typography variant='body1' color='textPrimary' style={{alignSelf: 'center'}}>
                    {t('common:filter')}:
                </Typography>
                <div className={classes.chips}>
                    {filter.map((item, index) => (
                        <Chip 
                            key={index} 
                            label={`${getFilterDisplayName(item.field)} = ${item.value}`}
                            color='primary'
                            onDelete={()=>_removeFilter(item.field)}
                        />
                    ))}
                </div>
                <Button
                    className={classes.addFilterButton}
                    color="secondary" 
                    variant='contained'
                    startIcon={<Add />}
                    onClick={_handleToggleFilterPopover}
                >
                    {t('add_filter')}
                </Button>
            </div>
            <Popover
                open={openFilters}
                onClose={_handleToggleFilterPopover}
            >
                <div style={{display: 'flex', flexDirection: 'row', overflow: 'hidden'}}>
                    <FormControl fullWidth variant="outlined" className={classes.formControl}>
                        <InputLabel id="resend-filter-field-label">{t('filter_name')}</InputLabel>
                        <Select
                            labelId='resend-filter-field-label'
                            value={filterFieldName}
                            label={t('filter_name')}
                            onChange={(event)=>setFilterFieldName(event.target.value)}
                        >
                            {filterModel.items.map((item, index) => (
                                <MenuItem key={index} value={item.columnField}>{item.displayName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {_.has(getFilterValues(filterModel.items, filterFieldName), 'selection') ? 
                        <FormControl fullWidth variant="outlined" className={classes.formControl}>
                            <InputLabel id="resend-filter-value-label">{t('filter_value')}</InputLabel>
                            <Select
                                labelId='resend-filter-value-label'
                                value={filterFieldValue}
                                label={t('filter_value')}
                                onChange={(event)=>_handleFilterComplete(event.target.value)}
                            >
                                {getFilterValues(filterModel.items, filterFieldName).selection.map((item, index) => (
                                    <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        :
                        null
                    }
                </div>
            </Popover>
        </Box>
    )
}

export default ResendOrderFilter